import { DIR, type Dir } from '../engine';

const MAP: Readonly<Record<string, Dir>> = {
  ArrowUp: DIR.UP,
  ArrowRight: DIR.RIGHT,
  ArrowDown: DIR.DOWN,
  ArrowLeft: DIR.LEFT,
  KeyW: DIR.UP,
  KeyD: DIR.RIGHT,
  KeyS: DIR.DOWN,
  KeyA: DIR.LEFT,
};

/** 개발·데스크톱 확인용. event.code 를 쓴다(자판 배열 무관). */
export function mountKeyboard(onDir: (d: Dir) => void): () => void {
  const h = (e: KeyboardEvent): void => {
    const d = MAP[e.code];
    if (d === undefined) return;
    e.preventDefault();
    onDir(d);
  };
  window.addEventListener('keydown', h);
  return () => window.removeEventListener('keydown', h);
}
